"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSkeleton = exports.Col = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const styled_bootstrap_grid_1 = require("styled-bootstrap-grid");
const react_loading_skeleton_1 = __importDefault(require("react-loading-skeleton"));
exports.Col = (0, styled_components_1.default)(styled_bootstrap_grid_1.Col) `
  padding: 0;
`;
exports.StyledSkeleton = (0, styled_components_1.default)(react_loading_skeleton_1.default) `
  margin: ${props => props.theme.spacing.s3}px 0;
`;
exports.default = {
    Col: exports.Col,
    StyledSkeleton: exports.StyledSkeleton
};
